import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectLogisticsConfigurationsQueryItem } from '../../../../../redux/logistics-Configurations/selector';

export const BookingMobile = () => {

    const logisticsConfigurations = useSelector(selectLogisticsConfigurationsQueryItem)
    const navigate = useNavigate();

    const handleParcelOrder = () => {
        navigate("/customer/bookings/parcel");
    }
    const handleCargoOrder = () => {
        navigate("/customer/bookings/cargo");
    }

    const orderBookingButtons: any = [

        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#6b7280" fill="none">
                    <path d="M2 13.4286V8H22V13.4286C22 17.4692 22 19.4895 20.6983 20.7447C19.3965 22 17.3014 22 13.1111 22H10.8889C6.69863 22 4.6035 22 3.30175 20.7447C2 19.4895 2 17.4692 2 13.4286Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2 8L2.96154 5.69231C3.70726 3.90257 4.08013 3.0077 4.8359 2.50385C5.59167 2 6.56112 2 8.5 2H15.5C17.4389 2 18.4083 2 19.1641 2.50385C19.9199 3.0077 20.2927 3.90257 21.0385 5.69231L22 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M12 8V2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M10 12H14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>,
            name: "Parcel Order",
            callback: () => handleParcelOrder(),
            isVisible: logisticsConfigurations?.result?.items?.LogisticsmConfigurations?.LogisticsOrderType == "ParcelAndCargo" || logisticsConfigurations?.result?.items?.LogisticsmConfigurations?.LogisticsOrderType == "Parcel" ? true : false,
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#6b7280" fill="none">
                    <circle cx="17" cy="18" r="2" stroke="currentColor" stroke-width="1.5" />
                    <circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="1.5" />
                    <path d="M11 17H15M13.5 7H14.4429C15.7533 7 16.4086 7 16.9641 7.31452C17.5196 7.62904 17.89 8.20972 18.6308 9.37107C19.1502 10.1854 19.6955 10.7765 20.4622 11.3024C21.2341 11.8318 21.6012 12.0906 21.8049 12.506C22 12.9038 22 13.375 22 14.3173C22 15.5596 22 16.1808 21.651 16.5755C21.636 16.5925 21.6207 16.609 21.6049 16.625C21.2375 17 20.6594 17 19.503 17H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M13 7L13.9942 9.48556C14.4813 10.7034 14.7249 11.3123 15.2328 11.6561C15.7407 12 16.3965 12 17.7081 12H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M4.86957 17C3.51684 17 2.84048 17 2.42024 16.5607C2 16.1213 2 15.4142 2 14V7C2 5.58579 2 4.87868 2.42024 4.43934C2.84048 4 3.51684 4 4.86957 4H10.1304C11.4832 4 12.1595 4 12.5798 4.43934C13 4.87868 13 5.58579 13 7V17H8.69565" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            name: "Cargo Order",
            callback: () => handleCargoOrder(),
            isVisible: logisticsConfigurations?.result?.items?.LogisticsmConfigurations?.LogisticsOrderType == "ParcelAndCargo" || logisticsConfigurations?.result?.items?.LogisticsmConfigurations?.LogisticsOrderType == "Cargo" ? true : false,
        }
    ];

    return (

        <div className="flex flex-col  gap-4 p-4 items-center justify-center space-y-5 min-h-[70vh] m-5">
            {orderBookingButtons?.length > 0 &&
                orderBookingButtons.map((button: any, index: number) => (
                    <button
                        key={index}
                        onClick={(event) => !button.disabled && button.callback(event)}
                        type="button"
                        disabled={button.disabled}
                        className={`${button.isVisible ? 'visible' : 'hidden'} flex items-center justify-center border border-gray-500 text-gray-700 px-6 py-6 rounded-md w-full sm:w-auto hover:bg-gray-100 transition gap-2`}
                        title={button.name === "Add Default" ? "Add Default web pages for all the vendors" : ""}
                    >
                        <span >{button.svg}</span>
                        <span className='pl-2 font-medium text-lg'>{button.name}</span>
                    </button>
                ))}
        </div>
    )
}
export default BookingMobile;
